const images = [
  {
    name: "Malabadi Köprüsü - DİYARBAKİR",
    src: "https://images.pexels.com/photos/8024439/pexels-photo-8024439.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Balıklı Göl - ŞANLIURFA",
    src: "https://images.pexels.com/photos/18379508/pexels-photo-18379508/free-photo-of-insanlar-kent-simgesi-anit-turkiye.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Nemrut Dağı - ADIYAMAN",
    src: "https://images.pexels.com/photos/9996125/pexels-photo-9996125.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Midyat Konuk - MARDİN",
    src: "https://images.pexels.com/photos/17027980/pexels-photo-17027980/free-photo-of-evler-yaz-kasaba-catilar.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Deyrulumur Manastırı – MARDİN",
    src: "https://images.pexels.com/photos/11533839/pexels-photo-11533839.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Kapadokya – NEVŞEHİR",
    src: "https://images.pexels.com/photos/3185493/pexels-photo-3185493.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Anıtkabir - ANKARA",
    src: "https://images.pexels.com/photos/7860240/pexels-photo-7860240.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Truva Antik Kenti – ÇANAKKALE",
    src: "https://images.pexels.com/photos/13032990/pexels-photo-13032990.jpeg?auto=compress&cs=tinysrgb&w=600",
  },

  {
    name: "Rumeli Hisarı – İSTANBUL",
    src: "https://images.pexels.com/photos/11087939/pexels-photo-11087939.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Galata Kulesi – İSTANBUL",
    src: "https://images.pexels.com/photos/19130967/pexels-photo-19130967/free-photo-of-kent-kent-simgesi-binalar-gemi.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Yerebatan Sarnıcı - İSTANBUL",
    src: "https://images.pexels.com/photos/18435002/pexels-photo-18435002/free-photo-of-ic-sutunlar-aydinlatilmis-turkiye.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Topkapı Sarayı - İSTANBUL",
    src: "https://images.pexels.com/photos/7000995/pexels-photo-7000995.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Kız Kulesi - İSTANBUL",
    src: "https://images.pexels.com/photos/17937320/pexels-photo-17937320/free-photo-of-deniz-kent-gun-batimi-kent-simgesi.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Dolmabahçe Sarayı - İSTANBUL",
    src: "https://images.pexels.com/photos/13461674/pexels-photo-13461674.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Manavgat Şelalesi - ANTALYA",
    src: "https://images.pexels.com/photos/14793916/pexels-photo-14793916.jpeg?auto=compress&cs=tinysrgb&w=600",
  },

  {
    name: "Kız Kalesi - MERSİN",
    src: "https://images.pexels.com/photos/17373585/pexels-photo-17373585/free-photo-of-deniz-kent-simgesi-ada-mavi-gokyuzu.jpeg?auto=compress&cs=tinysrgb&w=600",
  },

  {
    name: "Sümela Manastırı – TRABZON",
    src: "https://images.pexels.com/photos/17288902/pexels-photo-17288902/free-photo-of-kent-simgesi-doku-mimari-ucurum.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Ayder Yaylası - RİZE",
    src: "https://images.pexels.com/photos/17009790/pexels-photo-17009790/free-photo-of-peyzaj-daglar-orman-agaclar.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Uzungöl - TRABZON",
    src: "https://images.pexels.com/photos/8131397/pexels-photo-8131397.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Efes Antik Kenti - İZMİR",
    src: "https://images.pexels.com/photos/17575646/pexels-photo-17575646/free-photo-of-kent-peyzaj-bina-mimari.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export default images;
